@if (visible$()) {
  <div
    data-shortcut-layer="modal"
    class="sol-dialogs-container"
    [class.sol-dialogs-container-fade-in]="visibility$() === 'fadingIn'"
    [class.sol-dialogs-container-fade-out]="visibility$() === 'fadingOut'"
  >
    @for (entry of entries$(); track entry.id; let index = $index) {
      <div
        class="sol-dialog-container"
        role="dialog"
        [cdkTrapFocus]="index === entries$().length - 1"
        [cdkTrapFocusAutoCapture]="index === entries$().length - 1"
      >
        <sol-dialog-container [entry]="entry" />
      </div>
    }
  </div>
}
